/**
 * The copyable MCP-setup snippets, built from the caller's resolved endpoint
 * URL. Shared so web's settings tab and native's MCP screen offer byte-
 * identical commands — a drifted flag here would break a user's client setup
 * on one platform but not the other.
 */
export type McpCommand = {
  id: "endpoint" | "claude" | "codex";
  label: string;
  value: string;
};

export const buildMcpCommands = (mcpUrl: string) =>
  [
  { id: "endpoint", label: "MCP endpoint", value: mcpUrl },
  {
    id: "claude",
    label: "Claude Code command",
    value: `claude mcp add --transport http okthx ${mcpUrl}`,
  },
  {
    id: "codex",
    label: "Codex command",
    value: `codex mcp add --transport http okthx ${mcpUrl}`,
  },
] satisfies McpCommand[];
